var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.53 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f06;}.cls-2{fill:#fff;}.cls-3{fill:#f9c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "semi-basic form") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.39,45H21.14A21.15,21.15,0,0,1,0,23.86V21.14A21.15,21.15,0,0,1,21.14,0h84.39L102.2,23.71C99.78,37,92.07,45,80.39,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.76,13.31l1.59,4.91a1.31,1.31,0,0,0,1.24.9h5.16a1.3,1.3,0,0,1,.77,2.36l-4.18,3A1.31,1.31,0,0,0,30.87,26l1.59,4.91a1.3,1.3,0,0,1-2,1.46l-4.18-3a1.31,1.31,0,0,0-1.53,0l-4.18,3a1.3,1.3,0,0,1-2-1.46L20.16,26a1.29,1.29,0,0,0-.47-1.46l-4.18-3a1.31,1.31,0,0,1,.77-2.36h5.16a1.29,1.29,0,0,0,1.24-.9l1.6-4.91A1.3,1.3,0,0,1,26.76,13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.6,21.08l4.94-1.5a1.31,1.31,0,0,0,.93-1.22l.1-5.16A1.31,1.31,0,0,1,50,12.48l2.94,4.23a1.31,1.31,0,0,0,1.45.51l4.94-1.5a1.31,1.31,0,0,1,1.42,2l-3.12,4.11a1.31,1.31,0,0,0,0,1.53l3,4.24a1.31,1.31,0,0,1-1.5,2l-4.87-1.7a1.32,1.32,0,0,0-1.47.45l-3.12,4.11a1.3,1.3,0,0,1-2.34-.81l.1-5.16a1.3,1.3,0,0,0-.87-1.26l-4.88-1.69A1.3,1.3,0,0,1,41.6,21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.37,15.14,75,17.47a1.29,1.29,0,0,0,1.51-.24l3.64-3.67a1.3,1.3,0,0,1,2.21,1.12l-.79,5.1a1.32,1.32,0,0,0,.7,1.37l4.61,2.32a1.31,1.31,0,0,1-.38,2.45l-5.1.83a1.31,1.31,0,0,0-1.08,1.09l-.79,5.1a1.3,1.3,0,0,1-2.45.39l-2.35-4.59a1.32,1.32,0,0,0-1.37-.69l-5.1.83a1.31,1.31,0,0,1-1.13-2.21L70.75,23A1.32,1.32,0,0,0,71,21.49L68.62,16.9A1.3,1.3,0,0,1,70.37,15.14Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.e9fe100dab5b35cee485cbbdef4490ae.svg";
export { ForwardRef as ReactComponent };